import { useField } from 'formik';

import { FormBlock } from 'types';

import { FormViewProps } from '../types';

import { FormPreview } from './preview';

export const FormPreviewField = ({ blocksName }: FormViewProps) => {
  const [, { value: blocks }] = useField<FormBlock[]>(blocksName);

  return <FormPreview blocks={blocks} />;
};

export { FormPreview };
